import { Box, Button, Card, Chip, Stack, Typography } from '@mui/material';
import RedeemIcon from '@mui/icons-material/Redeem';
import React, { useState } from 'react';
import SubCard from 'ui-component/cards/SubCard';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SelectPremium from './SelectPremium';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Premiums } from 'store/actions';
import MediaControlCard from './MediaControlCard';
import NumberFormat from 'react-number-format';
const PremiumsList = ({ Premiumus, setPremiums }) => {
    const [OpenSelectPremium, setOpenSelectPremium] = useState(false);
    const [openBackdrop, setopenBackdrop] = useState(false);
    return (
        <>
            <SelectPremium
                open={OpenSelectPremium}
                setOpen={setOpenSelectPremium}
                openBackdrop={openBackdrop}
                setopenBackdrop={setopenBackdrop}
                setData={(para) => {
                    const uniqueModel = Premiumus.find((x) => x.premium_id === para.premium_id);
                    // console.log(para);
                    if (uniqueModel === undefined) {
                        // setProducts([...Products, para]);
                        setPremiums([...Premiumus, para]);
                    }
                }}
            />
            <SubCard
                title="Premiums"
                contentSX={{ p: 0 }}
                show={true}
                secondary={
                    <Button
                        variant="contained"
                        onClick={() => {
                            setOpenSelectPremium(true);
                        }}
                        startIcon={<AddShoppingCartIcon />}
                    >
                        Add
                    </Button>
                }
            >
                <PerfectScrollbar
                    key={Premiumus.length}
                    style={{ maxHeight: 'calc(100vh - 205px)', overflowX: 'hidden' }}
                    options={{ suppressScrollX: true, wheelPropagation: true }}
                >
                    {Premiumus.map((item) => {
                        return (
                            <MediaControlCard
                                key={item._id}
                                alt={item.premiumName}
                                image={item?.img || 'data:image/png;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                                onClickMinus={async () => {
                                    try {
                                        if (Premiumus.length !== 0) {
                                            const Amount = item.amount <= 1 ? 1 : Number(item.amount) - 1;
                                            if (Amount !== item.amount) {
                                                const NewArray = await Premiumus.map((itemArr) => {
                                                    return itemArr._id === item._id ? { ...itemArr, amount: Amount } : itemArr;
                                                });
                                                setPremiums(NewArray);
                                            }
                                        }
                                    } catch (error) {
                                        console.log(error);
                                        // dispatch({ type: Add_Premiums, premiums: NewArray });
                                        // setProducts(Products);
                                    }
                                }}
                                onClickPlus={async () => {
                                    try {
                                        if (Premiumus.length !== 0) {
                                            const limit = item.premiumstocks?.in - item.premiumstocks?.out || 0;
                                            const Amount =
                                                item.amount < 1
                                                    ? 1
                                                    : limit <= Number(item.amount)
                                                        ? Number(item.amount)
                                                        : Number(item.amount) + 1;

                                            if (Amount !== item.amount) {
                                                const NewArray = await Premiumus.map((itemArr) => {
                                                    return itemArr._id === item._id ? { ...itemArr, amount: Amount } : itemArr;
                                                });
                                                setPremiums(NewArray);
                                            }
                                        }
                                    } catch (error) {
                                        console.log(error);
                                        // setProducts(Products);
                                    }
                                }}
                                onChange={async (e) => {
                                    try {
                                        if (Premiumus.length !== 0) {
                                            const limit = item.premiumstocks?.in - item.premiumstocks?.out || 0;
                                            const Amount =
                                                e.target.value < 1
                                                    ? 1
                                                    : Number(e.target.value) < Number(limit)
                                                        ? Number(e.target.value)
                                                        : limit;
                                            // const Amount = e.target.value < 1 ? 1 : Number(e.target.value);
                                            if (Amount !== item.amount) {
                                                const NewArray = await Premiumus.map((itemArr) => {
                                                    return itemArr._id === item._id ? { ...itemArr, amount: Amount } : itemArr;
                                                });
                                                setPremiums(NewArray);
                                            }
                                        }
                                    } catch (error) {
                                        console.log(error);
                                        //setProducts(Products);
                                    }
                                }}
                                onClickDelete={() => {
                                    const data = Premiumus.filter((i) => i.premium_id !== item.premium_id);
                                    setPremiums(data);
                                }}
                                Body={
                                    <>
                                        <Stack>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Typography variant="subtitle1" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                                                    {item.premiumName.substring(0, 25)}
                                                </Typography>
                                                {item.__fromAnnouncement && (
                                                    <Chip
                                                        size="small"
                                                        icon={<RedeemIcon sx={{ fontSize: 12 }} />}
                                                        label="AUTO"
                                                        sx={{
                                                            height: 18,
                                                            fontSize: '0.65rem',
                                                            fontWeight: 700,
                                                            bgcolor: '#2E7D32',
                                                            color: '#fff',
                                                        }}
                                                    />
                                                )}
                                            </Stack>
                                            <Typography variant="caption" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                                                {'(' + item.premium_id + ')'}
                                            </Typography>
                                            <Stack direction="row" spacing={1}>
                                                <Typography variant="caption">Color:</Typography>
                                                <Typography variant="body2" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                                                    {item.color}
                                                </Typography>
                                            </Stack>
                                            {/* <Stack direction="row" spacing={1}>
                                                    <Typography variant="caption">Ram:</Typography>
                                                    <Typography variant="body2">{item.memory}</Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={1}>
                                                    <Typography variant="caption">Ram:</Typography>
                                                    <Typography variant="body2">{item.storage}</Typography>
                                                </Stack> */}
                                            {/* <Stack direction="row" spacing={1}>
                                                    <Typography variant="caption">Description:</Typography>
                                                    <Typography variant="body2">{item.description}</Typography>
                                                </Stack> */}
                                            <Stack direction="row" spacing={1}>
                                                <Typography variant="caption">{`Price:`}</Typography>
                                                <Typography
                                                    variant="body1"
                                                    color="#f57224"
                                                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                                >
                                                    <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.salePrice}
                                                        prefix="₭"
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={true}
                                                    />
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" spacing={1}>
                                                <Typography variant="caption">{`Stock:`}</Typography>
                                                <Typography variant="body2" color="#0c4da2">
                                                    {item.premiumstocks?.in - item.premiumstocks?.out || 0}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </>
                                }
                                value={item.amount}
                            />
                        );
                    })}
                </PerfectScrollbar>
                <Box sx={{ paddingLeft: '10px' }}>
                    <Stack direction="row" spacing={1}>
                        <Typography variant="subtitle1">{`Total:`}</Typography>
                        <Typography variant="subtitle1" color="#f57224">
                            <NumberFormat
                                thousandsGroupStyle="thousand"
                                value={
                                    Premiumus.length !== 0
                                        ? Premiumus.map((item) => item.salePrice * item.amount).reduce((prev, next) => prev + next)
                                        : 0
                                }
                                prefix="₭"
                                decimalSeparator="."
                                displayType="text"
                                type="text"
                                thousandSeparator={true}
                                allowNegative={true}
                            />
                        </Typography>
                    </Stack>
                </Box>
            </SubCard>
        </>
    );
};

export default PremiumsList;
